module.exports = __webpack_public_path__ + "img/dsci0138.b95d9ee6.jpg";